// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navbarlink_wrapper__3u6US","link":"navbarlink_link__17iVX","link--active":"navbarlink_link--active__3R1mv"};